import { create } from 'zustand';

export interface Toast {
  id: number;
  message: string;
  tone: 'info' | 'success' | 'error';
}

interface ToastState {
  toasts: Toast[];
  show: (message: string, tone?: Toast['tone']) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

/** Fila simples de toasts efêmeros (auto-dismiss em 3s, feito no componente). */
export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  show: (message, tone = 'info') =>
    set((s) => ({ toasts: [...s.toasts, { id: nextId++, message, tone }] })),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

/** Atalho fora de componentes React. */
export const toast = (message: string, tone?: Toast['tone']) =>
  useToastStore.getState().show(message, tone);
